import React, { useEffect, useState, useCallback } from "react";
import {
  Modal,
  Header,
  Button,
  Popup,
  Dropdown,
  Icon,
  Transition,
  Loader,
  Dimmer,
} from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import {
  copyText,
  downloadFile,
  fixMediaSize,
  scrollToTargetAdjusted,
  isTwitterMediaLink,
  ReadMore,
  ContentEditableWithRef,
  EditableTextContent,
  I18n,
  i18nKeys,
  replaceOrAppend
} from "../utils/functions";
import {
  shareLink,
  shareNativeWithFile,
  shareNativeWithoutFile,
  pickShareBehavior,
  instagramIcon,
} from "../utils/sharing";
import {
  gtagPostShare,
  setEditing,
  shortenUrl,
  trackPostShare,
  aiPostVariation,
  displayAiForSharers,
  editPostText,
} from "../../actions";
import reactStringReplace from "react-string-replace";
import "./PostCard.scss";
import { setShare } from "../utils/Amplitude";
import { isMobile } from "react-device-detect";
import { ButtonContainer, PrimaryCard } from "../styled-components";
import { toast } from "react-toastify";
import ThumbnailCard from "./ThumbnailCard";
import { useResizeDetector } from "react-resize-detector";

const GenericPostCard = (props) => {
  const state = useSelector((state) => state.sharer);
  const dispatch = useDispatch();
  const whitelabel = state.whitelabel;
  const hashtags = props.hashtags;
  const [open, setOpen] = useState(false);
  const [openIosInstagram, setOpenIosInstagram] = useState(false);  
  const [mediaModal, setMediaModal] = useState(false);
  const [mediaModalMobile, setMediaModalMobile] = useState(false);
  const [parsedLink, setParsedLink] = useState();
  const [shortenedLink, setShortenedLink] = useState();
  const regex = new RegExp("$(?:\n)", "g");
  const addSpace = !regex.test(props.text);
  const [fillIn, setFillIn] = useState(false);
  const [insertText, setInsertText] = useState([]);
  const [popup, setPopup] = useState(false);
  const [popupField, setPopupField] = useState(0);
  const [rect, setRect] = useState(null);
  const [displayImageFooter, setDisplayImageFooter] = useState();
  const [fullText, setFullText] = useState(
    addSpace && hashtags ? `${props.text.replace(/\[AI-BEGIN\]|\[AI-END\]/gi, "")} ${hashtags}` : `${props.text.replace(/\[AI-BEGIN\]|\[AI-END\]/gi, "")}${hashtags}`
  );
  const [editedText, setEditedText] = useState(fullText);
  const postID = props.id;
  const { editing } = props;
  const customText = state.customText;
  const imageID = props.image.id;
  const youtubeID = props.image.isYoutubeThumbnail ? props.image.filename : "";

  const link = props.link;
  const linkCaption = props.linkCaption;
  const [readMoreThresh,setReadMoreThresh] = useState(380);

  const [trigger, setTrigger] = useState(0);
  const [readMoreOpen,setReadMoreOpen] = useState(false);
  const [doJiggle, setDoJiggle] = useState(false);
  const [aiRequestInProgress, setAiRequestInProgress] = useState(false);
  const [textHistory, setTextHistory] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const [aiLabelTimeoutHandle, setAiLabelTimeoutHandle] = useState(null);
  const [originalText, setOriginalText] = useState(addSpace && hashtags ? `${props.text} ${hashtags}` : `${props.text}${hashtags}`);

  const i18n = new I18n(whitelabel?.userID);

  const {
    resolvedMedia,
    image: { filename, externalMediaID },
    resizeTrigger,
  } = props;
  let mediaType, media;

  const [fileAvailable, setFileAvailable] = useState(!externalMediaID || resolvedMedia !== undefined);

  if (resolvedMedia) {
    mediaType = resolvedMedia.media_type;
    media = resolvedMedia.url;
  } else if (filename.includes("giphy")) {
    mediaType = "giphy";
    media = filename;
  } else if (youtubeID) {
    mediaType = "youtube";
    media = `https://i.ytimg.com/vi/${filename}/hqdefault.jpg`;
  } else if (filename.slice(-4) === ".mp4") {
    mediaType = "video";
    media = filename;
  } else {
    mediaType = "image";
    media = `https://pic.speechifai.tech/1000x1000/${filename}`;
  }

  const [shareBehavior, setShareBehavior] = useState(
    pickShareBehavior(
      props.strategy.behavior,
      isMobile && props.deviceInfo.nativeSharingAvailable,
      mediaType,
      props.deviceInfo.os
    )
  );

  function checkFillInTheBlank() {
    if (!fillIn) {
      return true;
    }
    let retValue = true;
    insertText.map((obj, idx) => {
      if (retValue) {
        if (!obj || obj.text === "") {
          setPopupField(idx);
          setPopup(true);
          retValue = false;
        } else {
          setPopup(false);
        }
      }
    });

    return retValue;
  }

  const trackShare = (shareType = undefined) => {
    const platformName = props.strategy.config.platformName === "X / Twitter" ? "Twitter" : props.strategy.config.platformName;

    dispatch(
      trackPostShare(
        {
          campaignID: props.campaignID,
          sharedText: fullText,
          shared_url: mediaType === "image" ? parsedLink : "",
          sharedPlatform: shareType
            ? shareType
            : platformName,
          sharedImageURL: media,
          postType: "Ready Made Post",
          embed: state.wp,
          email: false,
        },
        state.apiMode
      )
    );

    if (state.apiMode === "prod") {
      dispatch(
        gtagPostShare({
          campaign_id: props.campaignID,
          campaign_name: state.readyMadeData.campaign.name,
          shared_text: fullText,
          shared_url: mediaType === "image" ? parsedLink : "",
          shared_platform: shareType
            ? shareType
            : platformName,
          shared_image_url: media,
          post_type: state.mode,
        })
      );
      setShare({
        Platform: shareType ? shareType : platformName,
      });
    } else {
      console.log(
        "TRACKING SHARE",
        shareType ? shareType : platformName
      );
    }
  };

  const optimize = async () => {
    if (!checkFillInTheBlank()) {
      return;
    }

    const newWindow = window.open("", "_blank");

    trackShare("Tweet Assistant");

    const linkToShare = await getLinkToShare();
    const newText = `${fullText} ${linkToShare}`;
    const encodedText = encodeURIComponent(newText);
    newWindow.location = `https://www.assistant.speechifai.tech/?utm_source=platform&text=${encodedText}`;
    newWindow.focus();
  };

  const sharePost = async () => {    
    if (!checkFillInTheBlank()) {
      return;
    }

    const linkToShare = await getLinkToShare();
    if (
      !props.strategy.config.textParam &&
      !props.strategy.config.urlParam &&
      linkToShare
    ) {
      copyText(`${fullText} ${linkToShare}`);
    }
    else if (!props.strategy.config.textParam) {
      copyText(`${fullText}`);
    }

    shareLink(fullText, linkToShare, props.strategy.config).then((ret) => {
      if (ret === 0) {
        trackShare();
      }
    });
  };

  const fillInsertText = (inputText) => {
    const tempText = reactStringReplace(
      inputText,
      /\[\[(.*?)\]\]/g,
      (match, i) => {
        return insertText[(i - 1) / 2];
      }
    );

    const newText = tempText.join("");
    return newText;
  };

  const handleInsert = (e, idx) => {
    const text = e.target.innerText;
    const newInsertText = insertText.slice();
    newInsertText[idx] = text;
    setInsertText(newInsertText);
    const newText = fillInsertText(props.text);
    setFullText(addSpace ? `${newText.replace(/\[AI-BEGIN\]|\[AI-END\]/gi, "")} ${hashtags}` : `${newText.replace(/\[AI-BEGIN\]|\[AI-END\]/gi, "")}${hashtags}`);
  };

  const downloadMedia = () => {
    downloadFile(media, mediaType);
  };

  async function getLinkToShare() {
    if (mediaType === "video" || mediaType === "gif") {
      return "";
    } else if (mediaType === "youtube") {
      return `https://www.youtube.com/watch?v=${youtubeID}`;
    } else if (mediaType === "giphy") {
      return shareBehavior === "shareLink" ? media : "";
    } else if (parsedLink && isTwitterMediaLink(parsedLink)) {
      return parsedLink;
    } else if (shortenedLink) {
      return shortenedLink;
    } else if (parsedLink) {
      return await dispatch(
        shortenUrl(
          {
            campaignID: props.campaignID,
            url: parsedLink,
            imageID: imageID,
            socialNetwork: state.platform,
            linkCaption: linkCaption,
          },
          state.apiMode
        )
      ).then((res) => {
        setShortenedLink(res);
        return res;
      });
    } else {
      return "";
    }
  }

  const customizeAndShare = async () => {    
    if (fullText === "" || editedText === "") {
      toast.error("Add text before sharing post", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    if (!checkFillInTheBlank()) {
      return;
    }

    const card = document.getElementById(props.id);
    if (card) {
      const rect = card.getBoundingClientRect();
      setRect(rect);
    }

    var ret = 1;
    if (
      shareBehavior === "nativeWithFile" ||
      shareBehavior === "nativeWithoutFile"
    ) {
      getLinkToShare();  // trigger link shortening
      setMediaModalMobile(true);
      return;
    } else if (shareBehavior === "shareLink") {
      // check if text needs to be copied to clipboard
      if (!props.strategy.config.textParam) {
        getLinkToShare();
        setOpen(true);
        if (state.wp) {
          scrollToTargetAdjusted(`modal-${props.id}`);
        }
        return;
      } else {
        ret = await shareLink(
          fullText,
          await getLinkToShare(),
          props.strategy.config
        );
      }
    } else if (shareBehavior === "downloadMedia") {
      getLinkToShare();  // trigger link shortening

      if(props.deviceInfo.os === "IOS" && props.socialNetwork === "instagram" &&
        (mediaType === "image" || mediaType === "gif")) {
        setOpenIosInstagram(true);
      } else {
        setMediaModal(true);
      if (state.wp) {
        scrollToTargetAdjusted(`media-modal-${props.id}`);
      }
      downloadMedia();
      }

      
      return;
    }

    if (ret === 0) {
      trackShare();
    }
  };

  const nativeShare = async () => {
    const linkToShare = await getLinkToShare();
    if (linkToShare) {
      copyText(`${fullText} ${linkToShare}`);
    } else {
      copyText(fullText);
    }

    var ret = 1;
    if (shareBehavior === "nativeWithFile") {
      const textToShare = props.strategy.config.nativeSkipText?.includes(
        props.deviceInfo.os
      )
        ? undefined
        : linkToShare
        ? `${fullText} ${linkToShare}`
        : fullText;

      ret = await shareNativeWithFile(media, mediaType, textToShare);
    } else {
      const textToShare = props.strategy.config.nativeSkipText?.includes(
        props.deviceInfo.os
      )
        ? undefined
        : fullText;
      ret = await shareNativeWithoutFile(textToShare, linkToShare);
    }

    if (ret === 0) {
      trackShare();
    }
  };

  const copyAndDownload = () => {
    if (!checkFillInTheBlank()) {
      return;
    }

    if (mediaType === "gif" || mediaType === "giphy" || mediaType === "video") {
      copyText(fullText);
    } else {
      copyText(`${fullText} ${parsedLink}`);
    }
    trackShare("Copy and Download");
    downloadMedia();
  };

  const onMediaLoadCallback = (e) => {
    if (props.strategy.config[mediaType]) {
      fixMediaSize(
        e.target,
        props.strategy.config[mediaType].minRatio,
        props.strategy.config[mediaType].maxRatio
      );
    } else {
      // keep original aspect ratio
      fixMediaSize(e.target, 0, 0);
    }
    triggerResize();
  };

  const onVideoLoadCallback = (e) => {
    let htmlImage;
    var parentDiv;

    try {
      htmlImage = document.createElement("img");
      htmlImage.setAttribute("src", e.target.poster);
      htmlImage.style.position = "fixed";
      htmlImage.style.display = "none";

      parentDiv = e.target.parentNode;
      if (parentDiv) {
        parentDiv.appendChild(htmlImage);
        if (props.strategy.config[mediaType]) {
          fixMediaSize(
            htmlImage,
            props.strategy.config[mediaType].minRatio,
            props.strategy.config[mediaType].maxRatio,
            parentDiv
          );
        } else {
          // keep original aspect ratio
          fixMediaSize(htmlImage, 0, 0, parentDiv);
        }
        triggerResize();
      }
    } catch (err) {
      console.error(err);
    } finally {
      if (parentDiv) {
        parentDiv.removeChild(htmlImage);
      }
    }
  };

  useEffect(() => {
    if (resolvedMedia) {
      setFileAvailable(true);
      mediaType = resolvedMedia.media_type;
      media = resolvedMedia.url;
    }
    if (parsedLink && isTwitterMediaLink(parsedLink) && isMobile) {
      setShareBehavior("nativeWithoutFile");
    } else {
      setShareBehavior(
        pickShareBehavior(
          props.strategy.behavior,
          isMobile && props.deviceInfo.nativeSharingAvailable,
          mediaType,
          props.deviceInfo.os
        )
      );
    }
  }, [resolvedMedia]);

  useEffect(() => {
    triggerResize();
  }, [resizeTrigger]);

  useEffect(() => {
    setDoJiggle((prev) => !prev);
  }, [open]);

  useEffect(() => {
    if(aiLabelTimeoutHandle) {
      clearTimeout(aiLabelTimeoutHandle);
      setAiLabelTimeoutHandle(null);
    }

    if(isHovered) {
      const h = setTimeout(() => {
        setAiLabelTimeoutHandle(null);
        setIsHovered(false);
      }, 5000);
      setAiLabelTimeoutHandle(h);
    }
  }, [isHovered]);

  useEffect(() => {
    if (link) {
      var newLink = props.url
        ? props.url
        : props.value
        ? `${link}${props.value}`
        : link;

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      newLink = reactStringReplace(
        newLink,
        /\[\[(.*?)\]\]/g,
        (match, i) => {
          const replaceParam = urlParams.get(match);
          if(replaceParam) {
            return encodeURIComponent(replaceParam);
          }
          else {
            return "[[" + match + "]]";
          }
        }
      );
      newLink = newLink.join("");

      if (newLink.substring(0, 2) === "@@") {
        newLink = newLink.slice(2);
        setShortenedLink(newLink);
      }

      if (
        mediaType !== "image" ||
        (!props.strategy.config.urlParam &&
          !props.strategy.config.textParam &&
          state.platform !== "native")
      ) {
        setDisplayImageFooter(false);
      } else if (
        props.socialNetwork === "twitter" &&
        isTwitterMediaLink(newLink)
      ) {
        setDisplayImageFooter(false);
      } else {
        setDisplayImageFooter(true);
      }

      if (isTwitterMediaLink(newLink) && isMobile) {
        setShareBehavior("nativeWithoutFile");
      }

      if (newLink) {
        try {
          const url = new URL(newLink);
          setParsedLink(url.href);
        } catch {
          console.log("Invalid link:", newLink);
          setParsedLink("");
        }
      }
    }
  }, [link]);

  /*
  useEffect(() => {
    if (hashtags.length === 0 && !fillIn && !editing) {
      setFullText(props.text);
    }
  }, [fullText]);*/

  useEffect(() => {
    // Checks edited text for any fill-in-the-blank matches
    const fillInRegex = new RegExp("\\[\\[(.*?)\\]\\]", "g");
    const matchRegex = editedText.match(fillInRegex);

    if (!matchRegex) {
      setFillIn(false);
    } else {
      setFillIn(true);
    }
  }, [editedText]);

  // Handles changes for editing
  useEffect(() => {
    let newText = props.text;
    const oldEditedText = editedText;
    
    if(insertText.length === 0) {
      const fillInRegex = new RegExp("\\[\\[(.*?)\\]\\]", "g");
      const textRegex = !fillInRegex.test(props.text);
      if (!textRegex) {
        setFillIn(true);
        const matchRegex = props.text.match(fillInRegex);
        setInsertText(Array(matchRegex.length).fill(""));    
      }
    } else {    
      let regex = /\[\[(.*?)\]\]/g;
      const matches = [];
      let match = regex.exec(oldEditedText);
      while (match !== null) {
        matches.push(match);
        match = regex.exec(oldEditedText);
      }

      const removeIdx = [];

      matches.forEach((match, index) => {
        const [fullMatch, innerText] = match;
        const replacement = insertText[index];

        if(newText.includes(fullMatch)) {
          if (typeof replacement !== "undefined" && replacement !== "") {
            newText = newText.replace(fullMatch,replacement);
          }
        } else {
          removeIdx.push(index);
        }
      });

      const newInsertText = insertText.slice();
      for (var i = removeIdx.length - 1; i >= 0; i--) {
        newInsertText.splice(removeIdx[i], 1);
      }
      setInsertText(newInsertText);
    }
    
    setEditedText(props.text);
    setFullText(newText.replace(/\[AI-BEGIN\]|\[AI-END\]/gi, ""));
    setTrigger((trigger) => trigger + 1);
  }, [props.text]);
  
  const [timeOutHandle,setTimeOutHandle] = useState(null);
  const triggerResize = () => {
    if(timeOutHandle) {
      clearTimeout(timeOutHandle);
    }
    const t = setTimeout(() => { onResize();}, 50);
    setTimeOutHandle(t);
  };

  const onResize = useCallback(() => {   
    if (ref && ref.current && state.wp && !state.multirow) {  //scrollDiff > 0 && scrollDiff < document.body.clientHeight
      document.body.style.overflow = "hidden";
      const scrollDiff = (document.body.scrollHeight - document.body.clientHeight);

      const imageFooter = ref.current.getElementsByClassName("content")[0];
      const expectedDiff = (imageFooter ? 106 : 42)+1;
      
      var isImage = true;
      var img = ref.current.getElementsByClassName("generic-thumbnail")[0];
      if(!img) {
        img = ref.current.getElementsByClassName("video-container")[0];
        isImage = false;
      }

      if(img) {
        const btn = ref.current.getElementsByClassName("generic-btn")[0];
        const rect1 = img.getBoundingClientRect();
        const rect2 = btn.getBoundingClientRect();

        const diff = rect2.top-rect1.bottom;
        const currentHeight = rect1.height;

        var increment = 0;
        var newHeight = 0;
        const minHeight = 100;
        const maxHeight = 300;

        if(diff <= expectedDiff && scrollDiff > 0) {
          newHeight = currentHeight - scrollDiff;
          if(newHeight < minHeight) {
            newHeight = minHeight;          
          }
          increment = -1;
        } else if(diff > expectedDiff+2 && scrollDiff <= 0) {
          const txt = ref.current.getElementsByClassName("post-text")[0];
          if(txt.style.overflowY === "visible") {
            var diffdiff = (diff - expectedDiff)-1;
            newHeight = currentHeight + diffdiff;
            if(newHeight > maxHeight) {
              newHeight = maxHeight;
            }
            increment = 1;
          }
        }

        const minWidth = rect1.height >= rect1.width ? 30 : 40;
        const maxWidth = 100;

        if(newHeight) {
          const factor = (newHeight / currentHeight);
          if(factor > 1 || scrollDiff > 0) {
            var newWidth = 300;
            if(factor > 1.02 || factor < 0.99) {
              const w = isImage ? 
                        (img.style.width ? img.style.width : "100%") : 
                        (img.style.getPropertyValue("--resize_aspect_ratio") ? 
                          img.style.getPropertyValue("--resize_aspect_ratio") : 
                          (img.style.getPropertyValue("--aspect_ratio") ?
                            img.style.getPropertyValue("--aspect_ratio") :
                            "100%"));
              const oldWidth = parseFloat(w.slice(0, -1));
              newWidth = oldWidth * factor;              
              newWidth = newWidth < minWidth ? minWidth : newWidth > maxWidth ? maxWidth : newWidth;
              const style = newWidth.toFixed(2) + "%";
              if(isImage) {
                img.style.width = style;
              } else {
                img.style.setProperty("--resize_aspect_ratio", style);
              }              
            } else {
              const w = isImage ? 
                        (img.style.width ? img.style.width : "100%") : 
                        (img.style.getPropertyValue("--resize_aspect_ratio") ? 
                          img.style.getPropertyValue("--resize_aspect_ratio") : 
                          (img.style.getPropertyValue("--aspect_ratio") ?
                            img.style.getPropertyValue("--aspect_ratio") :
                            "100%"));
              newWidth = parseFloat(w.slice(0, -1));
            } 

            const minSizeImg = newHeight < minHeight*1.5 || newWidth <= minWidth*1.05;
            const newScrollDiff = (document.body.scrollHeight - document.body.clientHeight);
            if( newScrollDiff > 0 && minSizeImg) {
              const txt = ref.current.getElementsByClassName("post-text")[0];
              const rectText = txt.getBoundingClientRect();
              const minTxtHeight = 150;
              if(readMoreOpen || editing) {              
                if(rectText.height > minTxtHeight) {
                  const newTextHeight = rectText.height - newScrollDiff < minTxtHeight ? minTxtHeight : rectText.height - newScrollDiff;
                  txt.style.overflowY = "scroll";
                  txt.style.maxHeight = newTextHeight.toFixed(1) + "px";                
                }
              } else if(readMoreThresh > 190 && rectText.height > minTxtHeight) {
                setReadMoreThresh((prev) => prev > 240 ? Math.floor(prev* 0.85) : prev-15); 
              }
            }
          }
        } 
      } else if(scrollDiff > 0) {
        // Youtube
        const txt = ref.current.getElementsByClassName("post-text")[0];
        const rectText = txt.getBoundingClientRect();
        const minTxtHeight = 150;
        if(readMoreOpen || editing) {              
          if(rectText.height > minTxtHeight) {
            const newTextHeight = rectText.height - scrollDiff < minTxtHeight ? minTxtHeight : rectText.height - scrollDiff;
            txt.style.overflowY = "scroll";
            txt.style.maxHeight = newTextHeight.toFixed(1) + "px";                
          }
        } else if(readMoreThresh > 190 && rectText.height > minTxtHeight) {
          setReadMoreThresh((prev) => prev > 240 ? Math.floor(prev* 0.85) : prev-15); 
        }
      }
    }
  }, [readMoreOpen,editing,readMoreThresh]);
  
  const { width, height, ref } = useResizeDetector({
    onResize,
    refreshMode: "throttle",
    refreshRate: 30,
    refreshOptions: { leading: false, trailing: true }
  });

  const expandReadMore = (expanded) => {
    setReadMoreOpen(expanded);
  };

  useEffect(() => {
    if(editing) {
      setReadMoreOpen(false);
    }

    if(!readMoreOpen && !editing) {
      const txt = ref.current.getElementsByClassName("post-text")[0];
      txt.style.maxHeight = "unset";
      txt.style.overflowY = "visible";
    } 

    triggerResize();
  },[readMoreOpen,editing]);

  return (
    <div 
      className={!state.wp || state.multirow ? "postcard-container" : "embed-postcard-container"}
      ref={ref}
    >
      <PrimaryCard
        className={!state.wp ? "postcard" : "embed-postcard"}
        id={props.id}
        bgColor={whitelabel.cardBackgroundColor}
        border={
          whitelabel.cardBorderColor
            ? `1px solid ${whitelabel.cardBorderColor}`
            : ""
        }
        radius={whitelabel.cardCornerRadius ? whitelabel.cardCornerRadius : "0"}
        shadow={
          whitelabel.dropShadow
            ? "0px 0px 6px 2px rgba(90, 90, 90, 0.1) !important"
            : "none !important"
        }
        footerBorder={
          whitelabel.pictureFooterBorderColor
            ? `1px solid ${whitelabel.pictureFooterBorderColor}`
            : ""
        }
        cardRadius={
          whitelabel.pictureFooterCornerRadius
            ? whitelabel.pictureFooterCornerRadius
            : "0"
        }
        textcolor={whitelabel.textColor}
        font={whitelabel.fontFamily}
        style={{ "--platform_color": props.strategy.config.color }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {editing ? (
          <div className="post-text">
            <EditableTextContent
              initialText={editedText}
              placeholderText={"Write post text here"}
              platformColor={props.strategy.config.color}
              postID={postID}
              insertText={insertText}
            />
          </div>
        ) : (
          <>
          <div className="post-text" style={{display: aiRequestInProgress ? "none":"block"}}>
            {customText &&  (
              <div
                className={`edit-btn-container ${isMobile && "edit-btn-container-mobile"}`}
              >
                {displayAiForSharers(props.text) &&
                  <>
                    {(textHistory.length > 0) &&
                      <div
                        className={`edit-btn ${isMobile && "edit-btn-mobile"}`}
                        style={{ "--platform_color": props.strategy.config.color }}
                        onClick={async () => {
                          dispatch(editPostText(postID, textHistory[textHistory.length-1])); 
                          setTextHistory((textHistory) => (textHistory.slice(0, -1)));                          
                        }}
                      >
                        <Icon name="undo" title="Back" />
                      </div>
                    }
                  
                  {/*
                    <Button as='div' labelPosition='left' className="ai-label-btn"
                    onClick={async () => {
                      setAiRequestInProgress(true);
                      aiPostVariation(fillInsertText(editedText), props.socialNetwork).then((result) => {
                        setAiRequestInProgress(false);
                        if(result) {
                          if ((editedText.includes("[AI-BEGIN]")) && (editedText.includes("[AI-END]"))) {
                            const parts = editedText.split("[AI-BEGIN]");
                            for(var i=1;i<parts.length;i++) {
                              const s = parts[i].split("[AI-END]")[0];
                              result = result.replace(s,"[AI-BEGIN]"+s+"[AI-END]");
                            }
                          }

                          setTextHistory(textHistory => [...textHistory, editedText]);
                          setEditedText(result);
                          setFullText(result.replace(/\[AI-BEGIN\]|\[AI-END\]/gi, ""));                           
                          setTrigger((trigger) => trigger + 1);
                          }
                      }).catch(() => {
                        setAiRequestInProgress(false);
                      });
                    }}
                    >
                  <Transition visible={isHovered && (textHistory.length <= 0)} animation='slide left' duration={600}>
                    <Label as='a' basic className="ai-label">Customize post with AI</Label>
                  </Transition>
                    <div
                      className={`edit-btn ${isMobile && "edit-btn-mobile"}`}
                      style={{ "--platform_color": props.strategy.config.color}}                      
                    >
                      <Icon name="wizard" title="AI-optimize text" />
                    </div>
                    </Button>
                */}
                </>  
                }

                <div
                  className={`edit-btn ${isMobile && "edit-btn-mobile"}`}
                  onClick={() => {
                    dispatch(setEditing(true, props.id));
                    if (!editedText.match(/\[\[.*?\]\]/)) {                    
                      setFillIn(false);
                    }
                  }}
                  style={{ "--platform_color": props.strategy.config.color }}
                >
                  <Icon name="edit" title="Edit text" />
                </div>
              </div>
            )}
            <ReadMore enable={true} thresh={readMoreThresh} onClick={(expand) => expandReadMore(expand)} i18n={i18n}>
              {fillIn
                ? reactStringReplace(
                    editedText.replace(/\[AI-BEGIN\]|\[AI-END\]/gi, "").trim(),
                    /\[\[(.*?)\]\]/g,
                    (match, i) => (
                      <Popup
                        open={popup && popupField === (i - 1) / 2}
                        onClose={() => {
                          setPopup(false);
                        }}
                        onOpen={() => {
                          setPopup(true);
                          setPopupField((i - 1) / 2);
                        }}
                        position="top right"
                        content={i18n.getText(i18nKeys.fillInBlank)}
                        className={`fill-in-the-blank-popup`}
                        style={{
                          "--platform_color": props.strategy.config.color,
                        }}
                        key={i}
                        trigger={
                          <ContentEditableWithRef
                            value={insertText[(i - 1) / 2]}
                            onChange={handleInsert}
                            trigger={trigger}
                            placeholderText={match.replace(/[[]]+/g, "")}
                            index={(i - 1) / 2}
                            platformColor={props.strategy.config.color}
                          />
                        }
                      />
                    )
                  )
                : editedText.replace(/\[AI-BEGIN\]|\[AI-END\]/gi, "").trim()}
            </ReadMore>
          </div>
          <div
            className="ai-post-loader"
            style={{display: aiRequestInProgress ? "block":"none"}}
          >
            <Dimmer
                  active
                  inverted
                  style={{ backgroundColor: "transparent" }}
                >
                <Loader inverted>
                  Generating text
                </Loader>
          </Dimmer>
          </div>
          </>
        )}
        <ThumbnailCard
          mediaType={mediaType}
          parsedLink={parsedLink ? parsedLink : media}
          onVideoLoadCallback={onVideoLoadCallback}
          onMediaLoadCallback={onMediaLoadCallback}
          displayImageFooter={displayImageFooter}
          media={media}
          linkCaption={linkCaption}
          image={props.image}
          resolvedMedia={resolvedMedia}
          textColor={whitelabel.textColor}
          font={whitelabel.font}
        />
        {/* Desktop Modal */}
        <Modal
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          open={open}
          id={`modal-${props.id}`}
          className="generic-modal"
          style={{
            "--platform_color": props.strategy.config.color,
            top:
              rect &&
              state.wp &&
              state.multirow &&
              rect.top + rect.height / 2 - 150,
          }}
        >
          <Modal.Header>
            {props.modalTitle ? props.modalTitle : "Text copied to your clipboard"}
          </Modal.Header>
          <Modal.Content>
            <div className="modal-check">
              <Transition
                animation={"tada"}
                duration={800}
                visible={doJiggle}
              >
                <Icon name="check" size="huge" />
              </Transition>
              <Modal.Description>
                <Header>
                  {props.modalPaste
                    ? props.modalPaste.replace("[platform]",props.strategy.config.platformName)
                    : `Continue to ${props.strategy.config.platformName} and use right-click → paste to carry over the text`}
                </Header>
              </Modal.Description>
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={() => sharePost()}>
              {props.modalButton
                ? `${props.modalButton} ${props.strategy.config.platformName}`
                : `Continue to ${props.strategy.config.platformName}`}
            </Button>
          </Modal.Actions>
        </Modal>
        <Modal
          onClose={() => setMediaModal(false)}
          onOpen={() => setMediaModal(true)}
          open={mediaModal}
          id={`media-modal-${props.id}`}
          className="generic-modal"
          style={{
            "--platform_color": props.strategy.config.color,
            top:
              rect &&
              state.wp &&
              state.multirow &&
              rect.top + rect.height / 2 - 150,
          }}
        >
          <Modal.Header>
            {props.modalTitle ? props.modalTitle : "Text copied"}
          </Modal.Header>
          <Modal.Content>
            <div className="modal-check">
              <Modal.Description>
                <Header>
                  {whitelabel && whitelabel.sharingPagePostCreationFollowSteps
                    ? whitelabel.sharingPagePostCreationFollowSteps
                    : "Follow these steps to create a post"}
                  : <br />
                  1.{" "}
                  {whitelabel && whitelabel.sharingPageClickToOpenSocialNetwork
                    ? replaceOrAppend(whitelabel.sharingPageClickToOpenSocialNetwork.trim(),"[platform]",props.strategy.config.platformName)
                    : `Click on the button below to open ${props.strategy.config.platformName}`}
                  <br />
                  {props.socialNetwork === "instagram" ? (
                    <>
                      2.{" "}{i18n.getText(i18nKeys.clickOnInstagramIcon,instagramIcon)}{" "}
                        <br />                      
                      3.{" "}
                      {whitelabel && whitelabel.sharingPageSelectDownloadedFile
                        ? whitelabel.sharingPageSelectDownloadedFile
                        : "Select your downloaded file"}{" "}
                      <br />
                      4.{" "}
                      {whitelabel && whitelabel.sharingPagePasteCaptionInTextbox
                        ? whitelabel.sharingPagePasteCaptionInTextbox
                        : "Paste the caption in the textbox"}
                    </>
                  ) : (
                    <>
                      2.{" "}
                      {whitelabel && whitelabel.sharingPageSelectDownloadedFile
                        ? whitelabel.sharingPageSelectDownloadedFile
                        : "Select your downloaded file"}{" "}
                      <br />
                      {!props.strategy.config.textParam && (
                        <>
                          3.{" "}
                          {whitelabel &&
                          whitelabel.sharingPagePasteCaptionInTextbox
                            ? whitelabel.sharingPagePasteCaptionInTextbox
                            : "Paste the caption in the textbox"}
                        </>
                      )}
                    </>
                  )}
                </Header>
              </Modal.Description>
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={sharePost}>
              {props.modalButton
                ? `${props.modalButton} ${props.strategy.config.platformName}`
                : "Continue to " + props.strategy.config.platformName}
            </Button>
          </Modal.Actions>
        </Modal>
        {/* Mobile Modal */}
        <Modal
          onClose={() => setMediaModalMobile(false)}
          onOpen={() => setMediaModalMobile(true)}
          open={mediaModalMobile}
          className="generic-modal-mobile"
          style={{ "--platform_color": props.strategy.config.color }}
        >
          <Modal.Header>
            {props.modalTitle ? props.modalTitle : "Text copied"}
          </Modal.Header>
          <Modal.Content>
            <div className="modal-check">
              <Modal.Description>
                <Header>
                  <>
                    {whitelabel && whitelabel.sharingPagePostCreationFollowSteps
                      ? whitelabel.sharingPagePostCreationFollowSteps
                      : "Follow these steps to create a post"}
                    : <br />
                    1.{" "}{i18n.getText(i18nKeys.openPhoneShareMenu,props.strategy.config.platformName)}{" "}
                    <br />                    
                    2.{" "}{state.platform !== "native" ? 
                      (i18n.getText(i18nKeys.selectPlatformApp,props.strategy.config.platformName) ):
                      (i18n.getText(i18nKeys.selectAppToShare))}{" "}
                    <br />
                    3.{" "}
                    {whitelabel && whitelabel.sharingPagePasteCaptionInTextbox
                      ? whitelabel.sharingPagePasteCaptionInTextbox
                      : "Paste the caption in the textbox"}
                  </>
                </Header>
              </Modal.Description>
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={nativeShare}>
              {state.platform !== "native" 
              ? (props.modalButton 
                ? `${props.modalButton} ${props.strategy.config.platformName}`
                : "Continue to " + props.strategy.config.platformName)
              : (i18n.getText(i18nKeys.openShareMenu))
                }
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal
          onClose={() => setOpenIosInstagram(false)}
          onOpen={() => setOpenIosInstagram(true)}
          open={openIosInstagram}
          className="insta-modal"
          style={{
            "--platform_color": props.strategy.config.color
          }}
        >
          <Modal.Content>
            <Header>
              1. Long press the image and select <b>Save&nbsp;Image</b>
            </Header>
            <ThumbnailCard
              mediaType={mediaType}
              onMediaLoadCallback={onMediaLoadCallback}
              displayImageFooter={false}
              media={media}
            />

            <Header>
              2. Click the button below to launch Instagram
            </Header>

            <Header>
              3. Create a new Story or Post, select the downloaded image and paste the text from your clipboard.
            </Header>
          </Modal.Content>
          <Modal.Actions>
            <Button
              onClick={async () => {
                const linkToShare = await getLinkToShare();
                if (linkToShare) {
                  copyText(`${fullText} ${linkToShare}`);
                } else {
                  copyText(fullText);
                }
                trackShare();
                setTimeout(() => {
                  window.open("https://www.instagram.com/", "_blank");
                },100);                  
              }}
            >
              {props.modalButton
                ? `${props.modalButton} Instagram`
                : "Continue to Instagram"}
            </Button>
           </Modal.Actions>          
        </Modal>



        <ButtonContainer
          className="postcard-buttons"
          radius={whitelabel.buttonCornerRadius}
          font={whitelabel.fontFamily}
        >


      {customText && displayAiForSharers(props.text) && !aiRequestInProgress &&
        <Popup
            mouseLeaveDelay={300}
            inverted
            trigger={
              <div
                className="generic-secondary-btn"
                style={{ "--platform_color": props.strategy.config.color}}
                radius={whitelabel.buttonCornerRadius}     
                onClick={async () => {
                  setAiRequestInProgress(true);
                  aiPostVariation(fillInsertText(originalText), props.socialNetwork).then((result) => {
                    if(result) {
                      if ((editedText.includes("[AI-BEGIN]")) && (editedText.includes("[AI-END]"))) {
                        const parts = editedText.split("[AI-BEGIN]");
                        for(var i=1;i<parts.length;i++) {
                          const s = parts[i].split("[AI-END]")[0];
                          result = result.replace(s,"[AI-BEGIN]"+s+"[AI-END]");
                        }
                      }
                      setTextHistory(textHistory => [...textHistory, editedText]);
                      dispatch(editPostText(postID, result)); 
                    }
                  }).catch((ex) => {
                    console.log("Request failed:", ex);
                  }).finally(() => {
                    setAiRequestInProgress(false);
                  });
                }}                 
              >
                <Icon name="wizard" size="large"/>
              </div>
            }>
              Customize your post with the help of AI
            </Popup>
           }
                

          <Button
            onClick={customizeAndShare}
            id={`button-${props.id}`}
            className={
              youtubeID === "" ? "generic-btn combined" : "generic-btn"
            }
            radius={whitelabel.buttonCornerRadius}
            font={whitelabel.fontFamily}
            title={props.share ? props.share : "Customize and share"}
            disabled={(shareBehavior==="downloadMedia" || 
                        shareBehavior==="nativeWithFile") && !fileAvailable}
          >
            {props.share ? props.share : "Customize and share"}
          </Button>
          {youtubeID === "" && (
            <Dropdown
              className="generic-btn-dropdown"
              scrolling={state.wp ? false : false}
              direction="left"
              upward={(state.wp && !state.multirow) ? true : false}
              disabled={(shareBehavior==="downloadMedia" || 
                        shareBehavior==="nativeWithFile") && !fileAvailable}
            >
              <Dropdown.Menu>
                {props.strategy.config.optimizeButtonAvailable &&
                  props.optimizeTweet && (
                    <Dropdown.Item
                      text={i18n.getText(i18nKeys.optimizeAndTweet)}
                      onClick={optimize}
                    />
                  )}
                <Dropdown.Item
                  text={
                    whitelabel && whitelabel.sharingPageDownloadCopy
                      ? whitelabel.sharingPageDownloadCopy
                      : "Copy and Download"
                  }
                  onClick={copyAndDownload}
                  disabled={!fileAvailable}
                />
              </Dropdown.Menu>
            </Dropdown>
          )}
        </ButtonContainer>
      </PrimaryCard>
    </div>
  );
};

export default GenericPostCard;
